export enum ProjectsViewFormat {
    Grid = 0,
    List = 1
}